export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL    = "GET_USER_FAIL";
export const SET_USER_NULL    = "SET_USER_NULL";